/* Size guide modal + inch/cm toggle */
(function () {
  function init() {
    var wrap = document.querySelector('.arc-sizeguide');
    if (!wrap || wrap.dataset.ready) return;
    wrap.dataset.ready = '1';

    var modal = wrap.querySelector('[data-arc-sg]');
    var last = null;

    function open() {
      last = document.activeElement;
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      var b = modal.querySelector('.arc-sg__x'); if (b) b.focus();
    }
    function close() {
      modal.hidden = true;
      document.body.style.overflow = '';
      if (last && last.focus) last.focus();
    }

    wrap.querySelectorAll('[data-arc-sg-open]').forEach(function (b) { b.addEventListener('click', open); });
    modal.querySelectorAll('[data-arc-sg-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });

    modal.querySelectorAll('[data-arc-sg-unit]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var cm = btn.dataset.arcSgUnit === 'cm';
        modal.querySelectorAll('[data-in]').forEach(function (el) { el.hidden = cm; });
        modal.querySelectorAll('[data-cm]').forEach(function (el) { el.hidden = !cm; });
        modal.querySelectorAll('[data-arc-sg-unit]').forEach(function (b) {
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
      });
    });
  }
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  if (document.readyState !== 'loading') init();
})();
